import { render } from "./IconEye.vue?vue&type=template&id=0725df88"
import script from "./IconEye.vue?vue&type=script&lang=ts"
export * from "./IconEye.vue?vue&type=script&lang=ts"
script.render = render

export default script